import { rgbToHex as base } from "@mui/system";

export function rgbToHex(
    color: string | null | undefined,
    fallback: string
): string {
    return color && color.length > 0 ?
        base(color) :
        fallback;
}
